import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import errorReducer from './errorReducer';
import notificationReducer from './notificationReducer';

const apiPortalRootReducer = combineReducers({
  login: loginReducer,
  error: errorReducer,
  notification: notificationReducer
});

export default apiPortalRootReducer;
